import type { DataWidgetFetcher } from "./createDataWidget";

/**
 * Simulated-latency fetcher for mock-backed widgets (thunks = workflow,
 * logic.ts = calculation — section 43): resolves the deterministic
 * generator's output after `latencyMs` and honors the thunk's abort signal.
 * Swapping in CubeJS replaces `mockFetch` with a real fetcher in the
 * widget's `state.ts` — a body-only change.
 */
export const MOCK_LATENCY_MS = 300;

export function mockFetch<TPoint, TParams = void>(
  generate: (params: TParams) => TPoint[],
  latencyMs: number = MOCK_LATENCY_MS,
): DataWidgetFetcher<TPoint, TParams> {
  return async (params, signal) => {
    const rows = await new Promise<TPoint[]>((resolve) => {
      setTimeout(() => resolve(generate(params)), latencyMs);
    });
    if (signal.aborted) {
      throw new Error("aborted");
    }
    return rows;
  };
}
